const circleDrawing = (fabricCanvas, fabric) => {
    let mouseDown = false
    let circle, origX, origY
    let isDrawing = false

    fabricCanvas.on('mouse:down', (o) => {
        if (!fabricCanvas.isDrawingCircle) return

        let pointer = fabricCanvas.getPointer(o.e)
        const activeObject = fabricCanvas.getActiveObject()

        if (!isDrawing && activeObject && activeObject.type === 'circle') {
            // The click is on the existing circle, it will be selected
            return
        } else {
            // Start drawing a new circle
            isDrawing = true
            mouseDown = true
            origX = pointer.x
            origY = pointer.y

            circle = new fabric.Circle({
                type: 'circle',
                left: origX,
                top: origY,
                originX: 'center',
                originY: 'center',
                radius: 0,
                selectable: false,
                fill: 'transparent',
                stroke: window.globalColor,
                strokeWidth: 2,
                strokeUniform: true,
                transparentCorners: false
            })

            fabricCanvas.add(circle)
            fabricCanvas.requestRenderAll()
        }
    })

    fabricCanvas.on('mouse:move', (o) => {
        if (!mouseDown) return

        let pointer = fabricCanvas.getPointer(o.e)

        let radius =
            Math.sqrt(
                Math.pow(origX - pointer.x, 2) + Math.pow(origY - pointer.y, 2)
            ) / 2

        // Update circle position to keep it centered
        let centerX = origX + (pointer.x - origX) / 2
        let centerY = origY + (pointer.y - origY) / 2

        circle.set({
            radius: radius,
            left: centerX,
            top: centerY
        })

        fabricCanvas.requestRenderAll()
    })

    fabricCanvas.on('mouse:up', () => {
        if (!mouseDown) return

        circle.setCoords()
        mouseDown = false
        isDrawing = false // Drawing finished
        circle.set({ selectable: true }) // Now the circle can be selected
        fabricCanvas.fire('object:modified')
        fabricCanvas.isDrawingCircle = true
    })
}

export default circleDrawing
